export default __webpack_public_path__ + "static/img_product_readingn-34aa45533791427c3bd43a40286841a5.png";